import isFunction from 'lodash/isFunction';

import { getGa } from 'core/googleAnalytics';

type EventCategory = 'TRANSLATIONS';

type EventAction =
  | 'START_PRIMARY_LANGUAGE_CHANGE'
  | 'CONFIRM_PRIMARY_LANGUAGE_CHANGE'
  | 'CANCEL_PRIMARY_LANGUAGE_CHANGE'
  | 'START_LANGUAGE_DELETION'
  | 'CONFIRM_LANGUAGE_DELETION'
  | 'CANCEL_LANGUAGE_DELETION';

type ReportPayload = {
  hitType: 'event';
  eventCategory: EventCategory;
  eventAction: EventAction;
  eventLabel?: string;
  eventValue?: number;
};

const report = (payload: ReportPayload) => {
  const ga = getGa();

  if (!isFunction(ga)) {
    return;
  }

  ga('send', payload);
};

export const reportPrimaryLanguageChangeStart = (language: Language) => {
  report({
    hitType: 'event',
    eventCategory: 'TRANSLATIONS',
    eventAction: 'START_PRIMARY_LANGUAGE_CHANGE',
    eventLabel: language,
  });
};

export const reportPrimaryLanguageChangeConfirmation = (language: Language) => {
  report({
    hitType: 'event',
    eventCategory: 'TRANSLATIONS',
    eventAction: 'CONFIRM_PRIMARY_LANGUAGE_CHANGE',
    eventLabel: language,
  });
};

export const reportPrimaryLanguageChangeCancellation = (language: Language) => {
  report({
    hitType: 'event',
    eventCategory: 'TRANSLATIONS',
    eventAction: 'CANCEL_PRIMARY_LANGUAGE_CHANGE',
    eventLabel: language,
  });
};

export const reportLanguageDeletionStart = (language: Language) => {
  report({
    hitType: 'event',
    eventCategory: 'TRANSLATIONS',
    eventAction: 'START_LANGUAGE_DELETION',
    eventLabel: language,
  });
};

export const reportLanguageDeletionConfirmation = (language: Language) => {
  report({
    hitType: 'event',
    eventCategory: 'TRANSLATIONS',
    eventAction: 'CONFIRM_LANGUAGE_DELETION',
    eventLabel: language,
  });
};

export const reportLanguageDeletionCancellation = (language: Language) => {
  report({
    hitType: 'event',
    eventCategory: 'TRANSLATIONS',
    eventAction: 'CANCEL_LANGUAGE_DELETION',
    eventLabel: language,
  });
};
